import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { VoidFn } from 'types/baseTypes';
import { LineItemPlusIcon } from 'assets/icons';

interface PlusButtonProps {
  id: string;
  onClick?: VoidFn;
  className?: string;
  disabled?: boolean;
  iconClassName?: string;
  label?: string;
}

const PlusButton: FC<PlusButtonProps> = ({
  id,
  onClick,
  className = '',
  disabled = false,
  iconClassName = '',
  label
}) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      id={id}
      type="button"
      onClick={handleClick}
      disabled={disabled}
      tabIndex={0}
      aria-label={label || 'Add'}
      className={`${className} flex cursor-pointer items-center gap-2 text-sbase font-semibold text-secondary 
        transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50`}>
      <LineItemPlusIcon id={`${id}-icon`} className={twMerge('w-5 h-5 shrink-0', iconClassName)} />
      {label && label}
    </button>
  );
};

export default PlusButton;
